import React, { ReactNode, useCallback, useMemo } from 'react';
import { openPopup2 } from "../../../../contexts/PopupContext";
import { callEventTrackingOp, state, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { STEP_STATUS } from "../../../../util/varibles/constants";
import { IPropsChildren } from "../../../../util/varibles/interface";
import LoadingBox from "../../../LoadingBox";
import ConfirmNextState from "./ConfirmNextState";
import styles from './style.module.scss';


interface IProps extends IPropsChildren {
    ids: string[]
    disabled?: boolean
    status: STEP_STATUS
    started?: Set<string>
    name?: ReactNode
}

const SubStep: React.FC<IProps> = ({ children, ids, disabled = false, status, started = new Set(), name }) => {
    const [loading] = useTrackingOp(state => state.loading);
    const { nextState } = callEventTrackingOp();

    const inactive = useMemo(() => {
        return status === STEP_STATUS.COMPLETED || (started.size > 0 && ids.some(id => !started.has(id))) || disabled;
    }, [ids, started, status, disabled]);

    const handleClick = useCallback(() => {
        if (!inactive) {
            openPopup2(<ConfirmNextState
                isComplete={false}
                name={name}
                onOk={() => nextState({ group_ids: ids, state: state[status || STEP_STATUS.STARTED] })}
            />)
        }
    }, [ids, status, name, inactive, nextState]);

    return <div
        className={styles.subStep}
        data-status={status}
        data-disabled={inactive}
        onClick={handleClick}
    >
        {(loading && !inactive) && <LoadingBox className='mr-1' loading={true} spinnerSize={18} />}
        <div>{children}</div>
    </div>;
};

export default SubStep;
